import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export default function Footer() {
  const { t, lang } = useLang();
  const col = (title, links) => (
    <div>
      <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">{title}</p>
      <ul className="space-y-3">
        {links.map(([to, key]) => (
          <li key={to}>
            <Link to={`/${lang}/${to}`} className="text-sm text-neutral-400 hover:text-ivory transition-colors">{t(key)}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
  return (
    <footer className="bg-[#070707] border-t border-white/10 mt-auto" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 py-16 md:py-20 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img src="/logo-crest.png" alt="Chef à Domicile" loading="lazy" className="h-20 w-auto mb-4" />
          <p className="font-serif text-2xl text-ivory mb-3">Chef <span className="text-gold italic">à</span> Domicile</p>
          <p className="text-sm text-neutral-500 leading-relaxed max-w-xs">{t("footer.tag")}</p>
        </div>
        {col(t("footer.explore"), [["chefs", "nav.chefs"], ["experiences", "nav.experiences"], ["private-dining", "nav.privateDining"], ["events", "nav.events"], ["gift-cards", "nav.giftCards"], ["journal", "nav.journal"]])}
        {col(t("footer.company"), [["about", "nav.about"], ["how-it-works", "nav.howItWorks"], ["corporate", "nav.corporate"], ["bespoke", "nav.bespoke"], ["become-a-chef", "nav.becomeChef"], ["contact", "nav.contact"]])}
        {col(t("footer.legal"), [["terms", "legal.termsTitle"], ["privacy", "legal.privacyTitle"], ["cancellation", "legal.cancelTitle"], ["faq", "nav.faq"]])}
      </div>
      <div className="border-t border-white/5 py-6 text-center px-4">
        <p className="text-xs text-neutral-600 tracking-wide" data-testid="footer-rights">{t("footer.rights")}</p>
      </div>
    </footer>
  );
}
